import {
  getProductCategoryFormList,
  getProductCategoryList,
  pathCreateProductCategory,
  pathDeleteProductCategory,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { productCategoryActions } from "../reducers/productCategory";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchProductCategoryList = (id_productCategory = 0) => {
  return (dispatch) => {
    return apiService
      .get(getProductCategoryList(id_productCategory))
      .then((response) => {
        id_productCategory == 0
          ? dispatch(
              productCategoryActions.fetchProductCategoryList(response.data)
            )
          : dispatch(
              productCategoryActions.fetchProductCategoryDetail(response.data)
            );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const clearProductCategoryDetail = () => {
  return (dispatch) =>
    dispatch(productCategoryActions.fetchProductCategoryDetail([]));
};

export const fetchProductCategoryAllList = (id_productCategory = 0) => {
  return (dispatch) => {
    return apiService
      .get(getProductCategoryList(id_productCategory))
      .then((response) => {
        dispatch(
          productCategoryActions.fetchProductCategoryAllList(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchProductCategoryAllFormList = (id_productCategory = 0) => {
  return (dispatch) => {
    return apiService
      .get(getProductCategoryFormList(id_productCategory))
      .then((response) => {
        dispatch(
          productCategoryActions.fetchProductCategoryAllFormList(response.data)
        );
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchClearProductCategoryAllFormList = () => {
  return (dispatch) => {
    dispatch(productCategoryActions.fetchProductCategoryAllFormList([]));
  };
};

export const fetchClearProdcutCategoryFormList = () => {
  return (dispatch) => {
    dispatch(productCategoryActions.fetchClearProdcutCategoryFormList());
  };
};

export const createNewProductCategory = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateProductCategory(), data)
      .then((response) => {
        // dispatch(productCategoryActions.fetchProductCategoryList(response.data));
        toast.success(t("productCategodyListActions.created"), {
          theme: "colored",
        });
        navigate("/product-category-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditProductCategory = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateProductCategory(), data)
      .then((response) => {
        // dispatch(productCategoryActions.fetchProductCategoryList(response.data));
        toast.success(t("productCategodyListActions.updated"), {
          theme: "colored",
        });
        navigate("/product-category-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteProductCategory = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteProductCategory(id))
      .then((response) => {
        toast.success(t("productCategodyListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchProductCategoryList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
